export default [
	"aa",
	"acww",
	"chatdd",
	"dgs",
	"chatplvsaa",
	"trilogy",
	"chatfuture",
	"legacy",
	"ddlc",
	"dr1",
	"chatdr2",
	"drv3",
	"drae",
	"chatp3",
	"p4",
	"p5",
	"chat999",
	"halla",
	"homestuck",
	"key",
	"yakuza",
	"yttd",
	"n64zelda",
	"papermario"
];